"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { WebInteractionDemo } from "../Demos/DeepActionFlow/InteractionDemos/WebInteractionDemo";
import Image from "next/image";

interface BrowserUseSectionProps {
  onDownloadClick?: () => void;
}

export function BrowserUseSection({ onDownloadClick }: BrowserUseSectionProps) {
  const actionRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: actionRef,
    offset: ["start center", "end end"],
  });

  const browserTexts = [
    "Browser Use gives our Agentic AI Browser power to automate entire workflows. From complex data scraping to form filling, it handles every step from a single command, delivering complete, start-to-finish automation.",
  ];

  // 第二阶段"Still clicking..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen ref={actionRef} onViewportEnter={() => console.log("Browser Use entered")} compact={true}>
        <div className="flex min-h-[400vh]">
          {/* Left Half - Progressive Text Display */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white mb-8 w-full">
                <div className="w-full">End-To-End </div> Web Automation
              </h2>
              {browserTexts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.5-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 relative mb-4">Still clicking through the web yourself?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou acts for you, like a pro.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Web Interaction Wireframe (Sticky) */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <WebInteractionDemo actionRef={actionRef} onDownloadClick={onDownloadClick} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
